<script>
import { layoutComputed } from '@/state/helpers';

import Vertical from './vertical';
import Horizontal from './horizontal';
import TwoColumns from './twocolumn';
import { ABILITY_TOKEN } from '@casl/vue';
import Swal from 'sweetalert2';

export default {
  inject: {
    $ability: { from: ABILITY_TOKEN },
  },
  components: {
    Vertical,
    Horizontal,
    TwoColumns,
  },
  props: {
    permissions: {
      type: Array,
    },
    module: {
      type: String,
    },
  },
  data() {
    return {
      hasPermission: true,
      showScrollTop: false,
    };
  },
  methods: {
    scrollToTop() {
      this.$refs.scrollSentinel.scrollIntoView({ behavior: 'smooth' });
    },
    checkPageAccess() {
      this.hasPermission = false;
      // console.log(this.permissions, this.defaultPermissions);
      if (this.permissions) {
        this.permissions.forEach((perm) => {
          if (this.$ability.can(perm, this.module)) this.hasPermission = true;
        });
      } else {
        this.defaultPermissions.forEach((perm) => {
          if (this.$ability.can(perm, this.module)) this.hasPermission = true;
        });
      }

      if (!this.hasPermission) {
        Swal.fire({
          title: 'Access denied!',
          text: 'You do not have permission on this module.',
          icon: 'error',
          confirmButtonColor: '#34c38f',
          cancelButtonColor: '#f46a6a',
          confirmButtonText: 'Ok',
        }).then(() => {
          this.$router.go(-1);
        });
      }
    },
  },
  computed: {
    ...layoutComputed,
    defaultPermissions() {
      return this.$store.state.permissions || [];
    },
  },
  mounted() {
    const authRequired = this.$route.matched.some((r) => r.meta?.authRequired);
    if (!authRequired) {
      this.hasPermission = true;
      return;
    }

    if (this.module) {
      this.checkPageAccess();
    }
    this._scrollObserver = new IntersectionObserver(([entry]) => {
      this.showScrollTop = !entry.isIntersecting;
    }, { threshold: 0 });
    this._scrollObserver.observe(this.$refs.scrollSentinel);
  },
  beforeUnmount() {
    if (this._scrollObserver) this._scrollObserver.disconnect();
  },
};
</script>


<template>
  <div>
    <div ref="scrollSentinel" style="position:absolute;top:0;height:1px;width:1px;pointer-events:none;"></div>

    <Vertical
      v-if="layoutType === 'vertical' || layoutType === 'semibox'"
      :layout="layoutType"
    >
      <slot v-if="hasPermission" />
    </Vertical>

    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
      <slot v-if="hasPermission" />
    </Horizontal>

    <TwoColumns v-if="layoutType === 'twocolumn'" :layout="layoutType">
      <slot v-if="hasPermission" />
    </TwoColumns>

    <transition name="scroll-top-fade">
      <button v-if="showScrollTop && $route.name !== 'search_center'" class="scroll-to-top-btn" @click="scrollToTop">
        <i class="ri-arrow-up-line"></i>
      </button>
    </transition>
  </div>
</template>

<style scoped>
.scroll-to-top-btn {
  position: fixed;
  bottom: 28px;
  right: 28px;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #f06548;
  color: #fff;
  border: none;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1050;
  box-shadow: 0 4px 12px rgba(240, 101, 72, 0.4);
  transition: background 0.2s;
}
.scroll-to-top-btn:hover {
  background: #d9543a;
}
.scroll-top-fade-enter-active,
.scroll-top-fade-leave-active {
  transition: opacity 0.25s, transform 0.25s;
}
.scroll-top-fade-enter-from,
.scroll-top-fade-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
</style>
